export default __webpack_public_path__ + "static/media/bg-section01.166f01e4.jpg";